import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronLeft, faChevronRight} from "@fortawesome/free-solid-svg-icons";

import "./Pagination.css";

export const Pagination = ({pageCount, currentPage, setCurrentPage}) => {

    const incrementPage = () => {
        if (currentPage < pageCount - 1) {
            setCurrentPage(prevState => prevState + 1);
        }
    }

    const decrementPage = () => {
        if (currentPage > 0) {
            setCurrentPage(prevState => prevState - 1);
        }
    }

    const goToFirstPage = () => {
        setCurrentPage(0);
    }

    const goToLastPage = () => {
        setCurrentPage(pageCount - 1);
    }

    return (
        <div className="pagination-container">
            <button className="pagination-button">
                <div className="pagination-double-chevron-container" onClick={goToFirstPage}>
                    <FontAwesomeIcon icon={faChevronLeft}/>
                    <FontAwesomeIcon icon={faChevronLeft}/>
                </div>
            </button>
            <button className="pagination-button" onClick={decrementPage}>
                <FontAwesomeIcon icon={faChevronLeft}/>
            </button>
            <div className="pagination-page-number-container">{`${currentPage + 1} of ${pageCount}`}</div>
            <button className="pagination-button" onClick={incrementPage}>
                <FontAwesomeIcon icon={faChevronRight}/>
            </button>
            <button className="pagination-button" onClick={goToLastPage}>
                <div className="pagination-double-chevron-container">
                    <FontAwesomeIcon icon={faChevronRight}/>
                    <FontAwesomeIcon icon={faChevronRight}/>
                </div>
            </button>
        </div>
    );
}